import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import "datatables.net-dt/css/jquery.dataTables.css";
import $ from "jquery";
import "datatables.net";

function Questions() {
    const navigate = useNavigate();
    const [questionsData, setQuestionsData] = useState([]);
    const [deleteQuestionId, setDeleteQuestionId] = useState("");
    const [deleteTitle, setDeleteTitle] = useState("");
    const [dataTable, setDataTable] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (questionsData.length) {
            if (dataTable) {
                dataTable.destroy();
            }
            const table = $("#questions").DataTable({
                data: questionsData,
                columns: [
                    { data: null, render: (data, type, row, meta) => meta.row + 1 }, // S.No
                    {
                        data: "question",
                        render: (data) => data.length > 50 ? data.substring(0, 50) + '...' : data
                    },
                    { data: "category" },
                    { data: "difficultyLevel" },
                    { data: "level" },
                    {
                        data: "activeStatus",
                        render: (data) => data ? '<span class="badge badge-success">Active</span>' : '<span class="badge badge-danger">Inactive</span>'
                    },
                    {
                        data: "createdAt",
                        render: (data) => new Date(data).toLocaleDateString(),
                    },
                    {
                        data: null,
                        render: (data) => {
                            return `
                <div align="center">
                  <a href="/question_add?id=${data.questionId}" class="crsr_pntr" title="Edit">
                    <i class="fa-solid fa-pen mr-2"></i>
                  </a>
                  <a href="#" class="crsr_pntr delete-btn" data-id="${data.questionId}" data-question="${data.question}" title="Delete">
                    <i class="fa-solid fa-trash text-danger"></i>
                  </a>
                </div>
              `;
                        },
                    },
                ],
                pageLength: 10,
                lengthMenu: [5, 10, 25, 50, 75, 100],
                order: [[6, 'desc']], // Sort by created date
            });
            setDataTable(table);

            // Event listener for the delete button
            $("#questions").on("click", ".delete-btn", function (e) {
                e.preventDefault();
                const questionId = $(this).data("id");
                const questionText = $(this).data("question");

                // Show confirmation alert
                const confirmed = window.confirm(`Are you sure you want to delete this question?\n\nQuestion: ${questionText}`);

                if (confirmed) {
                    deleteQuestion(questionId);
                }
            });
        }
    }, [questionsData]);

    const deleteQuestion = async (questionId) => {
        try {
            const response = await axios({
                method: "POST",
                url: process.env.REACT_APP_APIURL,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify({
                    environment: "live",
                    apikey: process.env.REACT_APP_APIKEY,
                    secret: process.env.REACT_APP_SECRET,
                    method: "deleteQuestion",
                    module: "question",
                    questionId: questionId,
                }),
            });

            const data = response.data;
            if (data.statusCode === 200) {
                alert("Question deleted successfully!");
                fetchData(); // Refresh the data
            } else {
                console.error("Failed to delete question:", data);
                alert(data.message || "Failed to delete question");
            }
        } catch (error) {
            console.error("Error deleting question:", error);
            alert("Error deleting question");
        }
    };

    const fetchData = async () => {
        try {
            const response = await axios({
                method: "POST",
                url: process.env.REACT_APP_APIURL,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify({
                    environment: "live",
                    apikey: process.env.REACT_APP_APIKEY,
                    secret: process.env.REACT_APP_SECRET,
                    method: "getAllQuestions",
                    module: "question",
                    index: 1,
                    limit: 1000, // Get all questions for DataTable
                }),
            });

            const data = response.data;
            if (data.statusCode === 200) {
                setQuestionsData(data.result.questions);
            } else {
                console.error("Failed to fetch questions:", data);
                setQuestionsData([]);
            }
        } catch (error) {
            console.error("Error fetching questions data:", error);
            setQuestionsData([]);
        }
    };

  

    const confirmDelete = async () => {
        try {
            const response = await axios({
                method: "POST",
                url: process.env.REACT_APP_APIURL,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify({
                    environment: "live",
                    apikey: process.env.REACT_APP_APIKEY,
                    secret: process.env.REACT_APP_SECRET,
                    method: "deleteQuestion",
                    module: "question",
                    questionId: deleteQuestionId,
                }),
            });

            const data = response.data;
            if (data.statusCode === 200) {
                $("#deleteModal").modal("hide");
                fetchData(); // Refresh the data
                // You can add a success toast here
            } else {
                console.error("Failed to delete question:", data);
                alert(data.message || "Failed to delete question");
            }
        } catch (error) {
            console.error("Error deleting question:", error);
            alert("Error deleting question");
        }
    };

    return (
        <div className="wrapper" id="root">
            <header>
                <NavigationBar />
            </header>

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 txt_lft">
                                    Questions Management
                                    <a href="/question_add">
                                        <i
                                            className="fa-solid fa-square-plus ml-2"
                                            title="Add Question"
                                        />
                                    </a>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="table-responsive">
                                    <table
                                        id="questions"
                                        className="table table-striped table-bordered txt_lft"
                                        style={{ width: "100%" }}
                                    >
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Question</th>
                                                <th>Category</th>
                                                <th>Difficulty</th>
                                                <th>Level</th>
                                                <th>Status</th>
                                                <th>Created Date</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />

            
        </div>
    );
}

export default Questions;